import core from '@/admin/core';

export const CREDIT_PAYMENT_TYPE = {
  STRIPE: 'stripe',
  GMO: 'gmo',
} as const;

export type CreditPaymentType = (typeof CREDIT_PAYMENT_TYPE)[keyof typeof CREDIT_PAYMENT_TYPE];

export interface EnvSettings {
  siteName?: string;
  siteSpaRoot?: string;
  account?: string;
  domainName?: string;
  tradeName?: string;
  copyright?: string;
  metaInfo?: string;
  statementDescriptor?: string;
  termsType?: string;
  unit04BasicSettingsType?: string;
  unit04SiteIntroductionPagePath?: string;
  hostedZoneId?: string;
  adminHostedZoneId?: string;
  stripePublicApiKey?: string;
  hostingBasicAuthUser?: string;
  hostingBasicAuthPass?: string;
  addminIpAddresses?: string[];
  assetsAccessControlAllowOrigins?: string[];
  birthdayEmailTemplateId?: string;
  ecSiteLink?: string;
  creditPaymentType?: CreditPaymentType;
  enableStripeCreditPayment: boolean;
  enableAuth: boolean;
  enableAdmin: boolean;
  enableContact: boolean;
  enableUserNumber: boolean;
  isRequiredSubscriptionForUserNumber: boolean;
  enableMailmagazine: boolean;
  enableForm: boolean;
  enablePayment: boolean;
  enableGift: boolean;
  enableGiftAntiFraudDisplay: boolean;
  enableConvenienceStorePayment: boolean;
  enableEcSite: boolean;
  enablePaidPlan: boolean;
  enableNoSubscription: boolean;
  enableBirthdayEmail: boolean;
  enableTalkRoom: boolean;
  enableSerialCode: boolean;
  enableChatRoom: boolean;
  enableFavoriteItem: boolean;
  enableSubscriptionCampaign: boolean;
  enableSubscriptionBoost: boolean;
  enableSchedule: boolean;
  enableVideo: boolean;
  enableMusic: boolean;
  enableShipping: boolean;
  enableInsights: boolean;
  enableLottery: boolean;
  enableV2SiteHosting: boolean;
  enablePreRelease: boolean;
  enableStopSignup: boolean;
  enableDeployBackend: boolean;
  enableDeployFrontend: boolean;
  enableDeployAdminConsole: boolean;
  enableAuPayment: boolean;
  enableDocomoPayment: boolean;
  enableSoftbankPayment: boolean;
  enablePaypayPayment: boolean;
  auPaymentServiceName?: string;
  auPaymentServicePhone?: string;
  convenienceStorePaymentSupportEmail?: string;
  convenienceStorePaymentSupportPhone?: string;
  convenienceStorePaymentSupportTime?: string;
  legacyStackName?: string;
  customAttirbuteSettings?: string[];
}

export interface EnvData {
  id: string;
  type: string;
  settings: EnvSettings;
}

let envSettingsCache: EnvSettings | null = null;

export const getEnvSettings = async () => {
  if (envSettingsCache) {
    return envSettingsCache;
  }

  const response = await core.httpClient.get('/admin/public/envSettings');
  const data = response.data as EnvData;
  envSettingsCache = data.settings;
  return envSettingsCache;
};

export const initEnvSettings = async () => {
  return await getEnvSettings();
};

export const getEnvSettingsSync = () => {
  if (!envSettingsCache) {
    console.warn('envSettings is not initialized');
  }
  return envSettingsCache;
};
